export default "__VITE_ASSET__DqYw7WnQ__"